import React, { Component } from 'react';
import { ReactSVG } from 'react-svg'
import styles from './Sidebar.module.css'


export class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.version = '1.4.3';
        this.state = {
            versionComponent: null
        }
    }

    onClickedModule = (moduleName) => {
        this.props.selectModule(moduleName);
    }

    renderModule(mod) {
        const classNames = [];
        classNames.push(styles[mod.class]);
        if(mod.selected) {
            classNames.push(styles['active'])
        }
        return (<div key={mod.id} className={styles['sidebar-icon']} 
        onClick={()=>this.onClickedModule(mod.id)}>
            <ReactSVG
                src={mod.icon}
                className={classNames.join(' ')}
            />
            <div className={styles['sidebar-icon-text']}>{mod.name}</div> 
        </div>)
    }

    componentDidMount() {
        setTimeout(() => {
            const apiVersion = localStorage.getItem('api_version');
            const versionComponent = <span>
                API: {apiVersion} <br/>
                Version: {this.version}
            </span>;
            this.setState({versionComponent})
        }, 1000);
    }

    render() {
        let modules = [];
        for (let mod of this.props.modules) {
            modules.push(this.renderModule(mod));
        }
        return <nav id="sidebar" className={this.props.isOpen ? '' : 'hide'}>
            {modules}
            {this.state.versionComponent}
        </nav>
    }
}